module.exports = __webpack_public_path__ + "img/certificate02-1-1.d68e1b15.jpg";